<template>
    <div class="fixed left-0 right-0 mx-auto z-[1000] px-[15px] laptop:px-0 transition-[transform,opacity] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] will-change-[transform,opacity] container mobile:top-[9px] tablet:top-[12px] laptop:top-[16px] mobile:px-[13px] tablet:px-[15px] !max-w-full laptop:!max-w-[1320px] largeDesktop:!max-w-[1440px] !bg-transparent"
        :class="{ '-translate-y-full opacity-0 pointer-events-none': !isHeaderVisible, 'z-[11] !absolute': $route.name == 'dashboard' }">
        <nav class="navbar navbar-expand-lg mobile:p-0 laptop:shadow-[0px_6px_20px_0px_#0000001A] laptop:pl-[11px] laptop:pr-[11px] largeDesktop:pl-[11px] largeDesktop:pr-[11px] laptop:py-[15px] laptop:rounded-[24px] laptop:bg-[#E9EEF6] transition-all duration-300"
            :class="isScrolled ? 'laptop:bg-[#E9EEF6]/90 laptop:backdrop-blur-md laptop:shadow-lg' : 'laptop:bg-[#E9EEF6] laptop:shadow-md'">
            <div class="relative laptop:flex items-center justify-between w-full">
                <div class="laptop:hidden flex items-center justify-between
                shadow-[0px_6px_20px_0px_#0000001A] mobile:px-[10px] tablet:px-[15px] py-[5px] rounded-[16px] bg-[#E9EEF6]
                laptop:shadow-none laptop:!p-0 laptop:rounded-none laptop:!border-0 laptop:!bg-transparent">
                    <a class="navbar-brand" :href="homePageUrl">
                        <img src="../../../assets/images/myHappyHomeBlueLogo.svg" alt="Logo"
                            class="w-[70px] h-[32.5px] tablet:w-[88px] tablet:h-[40px] laptop:w-[106px] laptop:h-[50px] object-contain">
                    </a>
                    <div class="flex items-center gap-[5px]">
                        <div v-if="$helper.isLoggedIn()"
                            class="relative w-[35px] h-[35px] tablet:w-[40px] tablet:h-[40px] flex items-center rounded-[50%] overflow-hidden shadow-[0px_0px_10px_0px_#00000026] border-[1px] border-[#fff]">
                            <button @click="profileModal()"
                                class="inline-flex justify-center items-center w-full h-full">
                                <img :src="getProfileImage()" alt="User Profile Icon"
                                    class="w-full h-full object-cover rounded-full">
                            </button>
                        </div>
                        <button class="!rounded-[10px] !p-[10px]  !bg-[#DEE4ED]" type="button" @click="toggoleButton()">
                            <div class="relative w-[20px] h-[18px] cursor-pointer">
                                <!-- Top -->
                                <span class="absolute left-0 h-[2px] w-full bg-[#10284C] rounded
           transition-all duration-500 origin-left" :class="isOpen
            ? 'rotate-45 top-[0px] left-[3px]'
            : 'top-0'"></span>

                                <!-- Middle -->
                                <span class="absolute left-0 top-[8px] h-[2px] w-full bg-[#10284C] rounded
           transition-all duration-300" :class="isOpen ? 'opacity-0 w-0' : ''"></span>

                                <!-- Bottom -->
                                <span class="absolute left-0 h-[2px] w-full bg-[#10284C] rounded
           transition-all duration-500 origin-left" :class="isOpen
            ? '-rotate-45 top-[14px] left-[3px]'
            : 'top-[16px]'"></span>
                            </div>

                        </button>
                    </div>
                </div>
                <div class="navbar-collapse flex-grow-0 z-10 mobile:overflow-hidden laptop:overflow-visible
                    shadow-[0px_6px_20px_0px_#0000001A] mobile:px-[15px] laptop:px-[16px] py-[10px]
                    rounded-[16px] bg-[#E9EEF6]
                    transition-all duration-500 ease-in-out
                    laptop:shadow-none laptop:!p-0 laptop:rounded-none laptop:!border-0 laptop:!bg-transparent
                    " :class="[
                        isMobileCollapse
                            ? 'mobile:max-h-[600px] mobile:opacity-100 mobile:translate-y-0'
                            : 'mobile:max-h-0 mobile:opacity-0 mobile:-translate-y-2 laptop:!opacity-100 laptop:!max-h-max laptop:translate-y-0 !py-[0px]',
                        'mobile:absolute mobile:top-[63px] tablet:top-[70px] laptop:relative laptop:top-0 left-0 mobile:w-full laptop:w-auto'
                    ]">

                    <ul v-if="!$helper.isLoggedIn()" class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item relative group/navLink transition-all ease-out mobile:transform laptop:transform-none mobile:delay-[0.20s] laptop:!delay-0"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]" :href="homePageUrl + '#services'">
                                Services
                            </a>
                        </li>
                        <li class="nav-item relative group/navLink transition-all ease-out mobile:transform delay-[0.25s]"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]" :href="homePageUrl + '#steps'">How It Works</a>
                        </li>
                        <li class="nav-item relative group/navLink transition-all ease-out mobile:transform delay-[0.30s]"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]" :href="homePageUrl + '#plans'">Plans</a>
                        </li>
                        <li class="nav-item relative group/navLink transition-all ease-out mobile:transform delay-[0.35s]"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]" :href="homePageUrl + '#promise'">Our Promise</a>
                        </li>
                        <li class="nav-item relative group/navLink transition-all ease-out mobile:transform delay-[0.40s]"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]" :href="homePageUrl + '#faq'">FAQ</a>
                        </li>
                    </ul>
                    <ul v-else class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li @click="dashboardClicked"
                            class="nav-item cursor-pointer relative group/navLink transition-all ease-out mobile:transform laptop:transform-none mobile:delay-[0.20s] laptop:!delay-0"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'">
                            <a class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C]
                            relative laptop:inline-block
                            after:content-['']
                            after:absolute after:left-0 after:bottom-[-2px]
                            after:h-[2px] after:w-full
                            laptop:after:bg-[#F5B134]
                            after:scale-x-0 after:origin-left
                            after:transition-transform after:duration-300 after:ease-out
                            group-hover/navLink:after:scale-x-100
                            laptop:group-hover/navLink:text-[#2459A8]
                            before:content-['']
                                before:absolute
                                before:left-0
                                before:top-1/2
                                before:-translate-y-1/2
                                before:w-[4px]
                                before:h-[1.4em]
                                before:bg-[#2459A8]
                                before:rounded-r
                                before:scale-y-0
                                before:origin-center
                                before:transition-transform
                                before:duration-300
                                mobile:before:block
                                laptop:before:hidden" :class="$route.path === '/dashboard'
                                    ? 'before:scale-y-100 mobile:text-[#2459A8] laptop:text-[#10284C] font-normal'
                                    : 'before:scale-y-0'">
                                Dashboard
                            </a>
                        </li>

                        <li v-for="(item, index) in mobileMenuItems" :key="index" class="nav-item laptop:hidden cursor-pointer relative group/navLink transition-all ease-out
                            mobile:transform laptop:transform-none
                            mobile:delay-[0.20s] laptop:!delay-0"
                            :class="isMobileCollapse
                                ? 'mobile:!translate-x-0 mobile:opacity-100 duration-500'
                                : 'mobile:-translate-x-[1rem] mobile:opacity-0 laptop:translate-x-0 laptop:opacity-100'" :style="{
                                    transitionDelay: isMobileCollapse ? `${0.2 + index * 0.1}s` : '0s'
                                }">
                            <div v-if="item.isDropdown" class="w-full">
                                <div @click="toggleBilling"
                                    class="nav-link flex items-center justify-between mobile:px-[15px] mobile:py-[16px] laptop:py-[8px] laptop:!px-[14px] font-poppins text-[16px] text-[#10284C] relative">
                                    <div class="absolute left-0 top-1/2 -translate-y-1/2 w-[4px] h-[1.4em] bg-[#2459A8] rounded-r transition-transform duration-300 origin-center"
                                        :class="($route.path === '/billings/methods' || $route.path === '/billings/transactions') ? 'scale-y-100' : 'scale-y-0'">
                                    </div>
                                    <span :class="($route.path === '/billings/methods' || $route.path === '/billings/transactions') ? 'text-[#2459A8] font-medium' : ''">{{ item.label }}</span>
                                    <svg class="w-4 h-4 transition-transform duration-300 text-[#10284C]"
                                        :class="{ 'rotate-180': isBillingExpanded, 'text-[#2459A8]': ($route.path === '/billings/methods' || $route.path === '/billings/transactions') }"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                        stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="6 9 12 15 18 9"></polyline>
                                    </svg>
                                </div>
                                <transition enter-active-class="transition-all duration-300 ease-out"
                                    enter-from-class="max-h-0 opacity-0" enter-to-class="max-h-[200px] opacity-100"
                                    leave-active-class="transition-all duration-200 ease-in"
                                    leave-from-class="max-h-[200px] opacity-100" leave-to-class="max-h-0 opacity-0">
                                    <div v-show="isBillingExpanded"
                                        class="overflow-hidden bg-transparent mx-[15px] mb-2 flex flex-col gap-1">
                                        <div @click="subMenuItemClicked('/billings/methods')"
                                            class="flex items-center gap-3 px-[20px] py-[10px] font-poppins text-[15px] transition-all duration-300"
                                            :class="$route.path === '/billings/methods' ? 'text-[#2459A8] font-medium' : 'text-[#10284C]'">
                                            <span class="w-[8px] h-[8px] rounded-full transition-all duration-300 transform"
                                                :class="$route.path === '/billings/methods' ? 'bg-[#2459A8] scale-100' : 'bg-[#10284C] scale-100 opacity-70'"></span>
                                            Payment Method
                                        </div>
                                        <div @click="subMenuItemClicked('/billings/transactions')"
                                            class="flex items-center gap-3 px-[20px] py-[10px] font-poppins text-[15px] transition-all duration-300"
                                            :class="$route.path === '/billings/transactions' ? 'text-[#2459A8] font-medium' : 'text-[#10284C]'">
                                            <span class="w-[8px] h-[8px] rounded-full transition-all duration-300 transform"
                                                :class="$route.path === '/billings/transactions' ? 'bg-[#2459A8] scale-100' : 'bg-[#10284C] scale-100 opacity-70'"></span>
                                            Transactions
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <a v-else @click="menuItemClicked(item)" class="nav-link mobile:block mobile:px-[15px] mobile:py-[16px]
                                laptop:py-[8px] laptop:!px-[14px]
                                font-poppins text-[16px] text-[#10284C]
                                relative laptop:inline-block

                                /* LEFT ACTIVE BAR */
                                before:content-['']
                                before:absolute
                                before:left-0
                                before:top-1/2
                                before:-translate-y-1/2
                                before:w-[4px]
                                before:h-[1.4em]
                                before:bg-[#2459A8]
                                before:rounded-r
                                before:scale-y-0
                                before:origin-center
                                before:transition-transform
                                before:duration-300
                                mobile:before:block
                                laptop:before:hidden

                                /* ACTIVE STATE */
                                " :class="$route.path === item?.path
                                    ? 'before:scale-y-100 text-[#2459A8] font-medium'
                                    : 'before:scale-y-0'">
                                {{ item.label }}
                            </a>
                        </li>
                    </ul>
                    <div v-if="$route.name != 'claim' || !$helper.isLoggedIn()"
                        class="laptop:hidden mt-[12px] pt-[16px] flex flex-col items-center gap-[8px] border-t-[1px] border-[#D5DCE6]">
                        <button v-if="$route.name != 'claim'" @click="createClaimClicked"
                            class="group relative mobile:w-full tablet:landscape:w-1/2 desktop:w-auto overflow-hidden inline-flex items-center justify-center gap-[6px] rounded-full transition-all duration-500 ease-out cursor-pointer
                        px-[15px] mobile:py-[10px] tablet:py-[12px] bg-[#f5b134] shadow-[0px_5px_10px_0px_#F5B1344D]
                         laptop:hover:shadow-[0px_5px_10px_0px_#F5B13466] laptop:hover:-translate-y-1 laptop:hover:scale-[1.02]
                         laptop:hover:bg-gradient-to-r laptop:hover:from-[#F5B134] laptop:hover:via-[#FFD68C] laptop:hover:to-[#F5B134]">
                            <span
                                class="font-poppins mobile:text-[14px] tablet:text-[16px] font-semibold text-[#10284C]">Create
                                a
                                Claim</span>
                            <!-- <img src="../../../assets/images/black-arrow-tilt.svg" alt="Arrow Icon"
                                 class="mobile:w-[14px] mobile:h-[14px] tablet:w-[18px] tablet:h-[18px] object-contain transition-transform duration-300 ease-out laptop:group-hover:translate-x-0.5 laptop:group-hover:-translate-y-0.5"> -->
                        </button>
                        <button @click="loginClicked" v-if="!$helper.isLoggedIn()"
                            class="group relative mobile:w-full tablet:landscape:w-1/2 desktop:w-auto overflow-hidden inline-flex items-center justify-center gap-[6px] rounded-full transition-all duration-500 ease-out cursor-pointer
                        px-[15px] mobile:py-[10px] tablet:py-[12px] bg-[#2459A8] shadow-[0px_5px_10px_0px_#2459A84D]
                         laptop:hover:shadow-[0px_5px_10px_0px_#F5B13466] laptop:hover:-translate-y-1 laptop:hover:scale-[1.02]
                         laptop:hover:bg-gradient-to-r laptop:hover:from-[#117ec2] laptop:hover:via-[#479bd0] laptop:hover:to-[#117ec2]">
                            <span
                                class="font-poppins mobile:text-[14px] tablet:text-[16px] font-semibold text-[#fff]">Sign
                                Up/Login</span>
                            <!-- <img src="../../../assets/images/white-arrow-tilt.svg" alt="Arrow Icon"
                                 class="mobile:w-[14px] mobile:h-[14px] tablet:w-[18px] tablet:h-[18px] object-contain transition-transform duration-300 ease-out laptop:group-hover:translate-x-0.5 laptop:group-hover:-translate-y-0.5"> -->
                        </button>
                    </div>
                </div>
                <div
                    class="absolute top-0 laptop:-right-[8px] largeDesktop:-right-[10px] hidden laptop:flex items-center justify-center h-full w-full">
                    <a class="navbar-brand" :href="homePageUrl">
                        <img src="../../../assets/images/myHappyHomeBlueLogo.svg" alt=""
                            class="w-[105.10px] h-[49px] object-contain hover:animate-jelly">
                    </a>
                </div>
                <div class="hidden laptop:flex items-center gap-[13px]">
                    <button v-if="$route.name != 'claim'" @click="createClaimClicked"
                        class="group relative overflow-hidden inline-flex items-center justify-center gap-[8px] rounded-full transition-all duration-500 ease-out cursor-pointer
                        pl-[15px] pr-[19px] py-[7.5px] bg-[#f5b134] shadow-[0px_5px_10px_0px_#F5B1344D]
                        hover:shadow-[0px_5px_10px_0px_#f5b13466] hover:-translate-y-1 hover:scale-[1.02]
                        laptop:hover:bg-gradient-to-r laptop:hover:from-[#F5B134] laptop:hover:via-[#ffce71] laptop:hover:to-[#F5B134]">
                        <span class="font-poppins text-[14px] font-semibold text-[#10284C]">Create a Claim</span>
                        <!-- <img src="../../../assets/images/black-arrow-tilt.svg" alt="Arrow Icon"
                            class="w-[17px] h-[17px] object-contain transition-transform duration-300 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"> -->
                    </button>
                    <button v-if="!$helper.isLoggedIn()" @click="loginClicked"
                        class="group relative overflow-hidden inline-flex items-center justify-center gap-[8px] rounded-full transition-all duration-500 ease-out cursor-pointer
                        pl-[15px] pr-[19px] py-[7.5px] bg-[#117ec2] shadow-[0px_5px_10px_0px_#2459A866]
                        hover:shadow-[0px_5px_10px_0px_#117ec266] hover:-translate-y-1 hover:scale-[1.02]
                        laptop:hover:bg-gradient-to-r laptop:hover:from-[#117ec2] laptop:hover:via-[#479bd0] laptop:hover:to-[#117ec2]">
                        <span class="font-poppins text-[14px] font-semibold text-[#fff]">Sign Up/Login</span>
                        <!-- <img src="../../../assets/images/white-arrow-tilt.svg" alt="Arrow Icon"
                            class="w-[17px] h-[17px] object-contain transition-transform duration-300 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"> -->
                    </button>
                    <!-- Profile Button -->
                    <div v-else
                        class="relative w-[35px] h-[35px] tablet:w-[40px] tablet:h-[40px] flex items-center rounded-[50%] overflow-hidden shadow-[0px_0px_10px_0px_#00000026] border-[1px] border-[#fff]">
                        <button @click="profileModal()" class="inline-flex justify-center items-center w-full h-full">
                            <img :src="getProfileImage()" alt="User Profile Icon"
                                class="w-full h-full object-cover rounded-full">
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    </div>

    <!-- Profile Modal -->
    <div class="modal fade" id="profileModal" ref="profileModal" tabindex="-1" aria-labelledby="profileModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[400px] laptop:px-0 !absolute tablet:!right-4 laptop:!right-8 !top-0 !m-0 h-full">
            <div class="modal-content select-none">
                <div class="modal-body !p-2.5 !pb-5">
                    <div class="relative ">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <!-- <font-awesome-icon icon="times" class="w-full h-full font-light text-white" /> -->
                            <img src="../../../assets/images/white-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                    </div>
                    <div class="">
                        <headerUserProfile :openModal="profileModalOpen" :clickedCallback="clickedCallback"
                            :userObject="user" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    mapGetters, mapActions
} from "vuex";
import headerUserProfile from "../../nest_components/header_profile.vue";
import defaultProfile from '../../../assets/images/default-img.svg';
export default {
    components: {
        headerUserProfile,
    },
    data() {
        return {
            isMobileCollapse: false,
            isOpen: false,
            isHeaderVisible: true,
            isScrolled: false,
            lastScrollPosition: 0,
            isBillingExpanded: false,
            profileModalOpen: new Date(),
            user: JSON.parse(localStorage.getItem('user')) ?? null,
            scrollTarget: null,
            mobileMenuItems: [
                { label: "Protection Plans", path: "/plans" },
                { label: "Purchase Plans", path: "/purchases" },
                { label: "Claim History", path: "/work-order/list" },
                { label: "Billing History", path: "/billings/methods", isDropdown: true }
            ]
        }
    },
    mounted() {
        this.scrollTarget = this.findScrollContainer(this.$el);
        this.scrollTarget.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    },
    beforeUnmount() {
        if (this.scrollTarget) {
            this.scrollTarget.removeEventListener('scroll', this.handleScroll);
        }
    },
    computed: {
        ...mapGetters(["userObject", "updateStatusResponse", "signOutResponse"]),
        homePageUrl() {
            const url = process.env.VUE_APP_HOME_PAGE_URL || 'https://myhappyhome.com';
            return url.endsWith('/') ? url : url + '/';
        }
    },
    watch: {
        updateStatusResponse: function () {
            if (this.$helper.isLoggedIn()) {
                this.getProfile({})
            }
        },

        userObject: function () {
            this.user = this.userObject
            localStorage.setItem('user', JSON.stringify(this.user))
        },

        signOutResponse: function (val) {
            if (val) {
                localStorage.removeItem('user')
                localStorage.removeItem('isSilentLogin')
                localStorage.removeItem('isProtectionPlans')
                localStorage.removeItem('is_from_mobile')
                this.resetSate()
                this.$router.replace({
                    name: 'login'
                })
            }
        },
    },
    methods: {
        ...mapActions(["signOut", "resetSate",]),
        loginClicked() {
            this.$router.push({ name: 'login' })
        },
        findScrollContainer(el) {
            if (!el) return window;
            let parent = el.parentElement;
            while (parent) {
                const style = window.getComputedStyle(parent);
                if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
                    return parent;
                }
                parent = parent.parentElement;
            }
            return window;
        },
        handleScroll() {
            const st = this.scrollTarget === window
                ? (window.scrollY || window.pageYOffset || document.documentElement.scrollTop)
                : (this.scrollTarget ? this.scrollTarget.scrollTop : 0);

            // Get total scrollable height to detect bottom bounce
            const scrollHeight = this.scrollTarget === window
                ? document.documentElement.scrollHeight
                : this.scrollTarget.scrollHeight;
            const clientHeight = this.scrollTarget === window
                ? document.documentElement.clientHeight
                : this.scrollTarget.clientHeight;
            const maxScroll = scrollHeight - clientHeight;

            // Prevent negative scroll values (top bounce) and exceeding max scroll (bottom bounce)
            const clampedSt = Math.max(0, Math.min(st, maxScroll));

            this.isScrolled = clampedSt > 30;

            // Delta threshold to ignore small scrolls (prevents flickering)
            const threshold = 5;
            const delta = clampedSt - this.lastScrollPosition;

            // Only update visibility if scroll change is more than threshold
            if (Math.abs(delta) > threshold) {
                // Show header if:
                // 1. Scrolling UP (delta < 0)
                // 2. Near top (clampedSt < 30)
                this.isHeaderVisible = clampedSt < 30 || delta < 0;
                this.lastScrollPosition = clampedSt;
            } else if (clampedSt < 30) {
                // Ensure header is visible at the very top even if delta is small
                this.isHeaderVisible = true;
                this.lastScrollPosition = clampedSt;
            }
        },
        getProfileImage() {
            // Check if user and profile_picture exist
            return this.user?.user?.profile_picture || defaultProfile;
        },
        adjustModalHeight() {
            const modalContent = this.$refs.profileModal?.querySelector('.profile-modal-content');
            if (modalContent) {
                const vh = window.innerHeight;
                modalContent.style.maxHeight = `${vh - 200}px`; // adjust padding as needed
                modalContent.style.overflowY = 'auto';
            }
        },
        profileModal() {
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.profileModal;
            // this.sideMenuClicked()
            let modal = Modal.getInstance(modalEl);
            if (!modal) {
                modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element

                this.adjustModalHeight();
            });
            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                window.removeEventListener('resize', this.adjustModalHeight);
                window.removeEventListener('orientationchange', this.adjustModalHeight);
            });

            this.profileModalOpen = new Date()
            // Add orientation/resize responsiveness
            window.addEventListener('resize', this.adjustModalHeight);
            window.addEventListener('orientationchange', this.adjustModalHeight);
            modal.show();
        },
        clickedCallback(option) {
            if (option == 'signout') {
                this.signoutClicked()
            }
        },
        signoutClicked() {
            const originalPadding = document.documentElement.style.padding || '';
            // Remove padding from HTML element
            document.documentElement.style.padding = '0';
            document.documentElement.style.paddingRight = '0';
            this.$confirmDialog.show({
                image: 'logout-confirm-icon.svg',
                title: "Sign Out",
                text: "Are you sure you want to sign out?",
                buttonText: "Confirm",
                isShowConfirmText: true,
                // image: "pop-req-img.png",
                // we are passing callback method for our confirm button
                onConfirm: () => {
                    this.signOut({})
                },
            });
        },
        dashboardClicked() {
            this.isMobileCollapse = false
            this.isOpen = false
            this.$router.push({ 'name': 'dashboard' })
        },
        createClaimClicked() {
            this.isMobileCollapse = false
            this.isOpen = false
            this.$router.push({ 'name': 'claim' })
        },

        toggoleButton() {
            this.isMobileCollapse = !this.isMobileCollapse
            this.isOpen = !this.isOpen
        },

        menuItemClicked(item) {
            if (item.isDropdown) {
                this.toggleBilling();
                return;
            }
            if (item.path) {
                this.$router.push(item.path)
            }
            this.toggoleButton()
        },

        toggleBilling() {
            this.isBillingExpanded = !this.isBillingExpanded;
        },

        subMenuItemClicked(path) {
            this.$router.push(path);
            this.toggoleButton();
        }
    }
}
</script>